import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneMask',
  pure: true
})
export class PhoneMaskPipe implements PipeTransform {

  /**
   * maskChar: character used for mask (default '*')
   * showFirst: number of digits to leave visible at start (default 4)
   * showLast: number of digits to leave visible at end (default 3)
   */
  transform(value: string | null | undefined, maskChar = '*', showFirst = 4, showLast = 3): string {
    if (!value) {
        return '';
    }

    // keep original non-digit separators (like +, spaces, dashes) while masking digits
    const chars = value.split('');
    const digits = chars.map(c => /\d/.test(c) ? c : null);

    // count digits
    const digitCount = digits.reduce((s, d) => s + (d ? 1 : 0), 0);
    if (digitCount === 0) {
        return value;
    }

    // decide which digit positions to reveal: first showFirst digits, last showLast digits
    // ensure we don't reveal more than exist
    const revealFirst = Math.min(showFirst, digitCount);
    const revealLast = Math.min(showLast, Math.max(0, digitCount - revealFirst));

    // create an array of indexes of digit positions
    let digitIndex = 0;
    return chars.map(ch => {
      if (!/\d/.test(ch)) {
        return ch; // non-digit keep
      }
      const keep = (digitIndex < revealFirst) || (digitIndex >= digitCount - revealLast);
      digitIndex++;
      return keep ? ch : maskChar;
    }).join('');
  }
}
